import React from 'react';

import { cn } from '@/lib/utils';

import { BADGE_BASE_CLASSES } from './shared';

interface InfoBadgeProps extends React.HTMLAttributes<HTMLElement> {
  label: string;
  value: string | React.ReactNode;
  onClick?: () => void;
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
  showLabel?: boolean;
}

export const InfoBadge = React.forwardRef<HTMLElement, InfoBadgeProps>(
  (
    {
      label,
      value,
      onClick,
      className = '',
      labelClassName = '',
      valueClassName = '',
      showLabel = true,
      ...props
    },
    ref,
  ) => {
    if (!value) return null;

    const Component = onClick ? 'button' : 'div';

    return (
      <Component
        ref={ref as React.Ref<HTMLButtonElement & HTMLDivElement>}
        onClick={onClick}
        onKeyDown={(e: React.KeyboardEvent<HTMLElement>) => {
          if (onClick && e.key === 'Enter') onClick();
          props.onKeyDown?.(e);
        }}
        className={cn(
          BADGE_BASE_CLASSES,
          className,
          !onClick && 'cursor-default',
        )}
        aria-label={onClick ? `Edit ${label}` : undefined}
        type={onClick ? 'button' : undefined}
        {...props}
      >
        {showLabel && (
          <span className={cn('text-zinc-500 mr-1', labelClassName)}>
            {label}:
          </span>
        )}
        <span className={cn('font-medium', valueClassName)}>{value}</span>
      </Component>
    );
  },
);

InfoBadge.displayName = 'InfoBadge';
